<!--发起测评-->
<template>
    <div id="InitiateEvaluation">
        <a-breadcrumb>
            <a-breadcrumb-item>
                <router-link :to="decodeURIComponent($route.query.fullPath)">课程管理</router-link>
            </a-breadcrumb-item>
            <a-breadcrumb-item>{{ courseInfo ? '编辑' : '添加' }}课程</a-breadcrumb-item>
        </a-breadcrumb>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
            <a-steps style="width: 950px;" :current="current">
                <a-step :title="'选择课程资源'"/>
                <a-step title="配置学生"/>
                <a-step title="确认信息"/>
            </a-steps>
        </div>
        <div class="content">
            <StepsFirst @steps="n => this.current = n" v-if="current === 0"/>
            <StepsSecond @steps="n => this.current = n" v-if="current === 1"/>
            <StepsThird @steps="n => this.current = n" v-if="current === 2"/>
        </div>
    </div>
</template>

<script>
import StepsFirst from '@/pages/projectImpl/courseManage/components/steps/StepsFirst.vue'
import StepsSecond from '@/pages/projectImpl/courseManage/components/steps/StepsSecond'
import StepsThird from '@/pages/projectImpl/courseManage/components/steps/StepsThird'
import $Bus from "@/pages/projectImpl/js/eventBus";

export default {
    name: 'InitiateEvaluation',
    components: {
        StepsFirst,
        StepsSecond,
        StepsThird
    },
    data() {
        return {
            courseInfo: this.$store.getters["organization/getOrganizationInfo"](),
            current: 0,
            textTit: this.$route.query.textTit
        }
    },
    mounted() {
        let text = '添加课程';
        if (this.$route.query.id) {
            text = '编辑课程'
        }
        const arr = ["首页", "项目实施",
            {
                name: "课程管理",
                path: decodeURIComponent(this.$route.query.fullPath)
            }, text];
        $Bus.$emit("pageHeaderBreadcrumb", arr);
        $Bus.$emit("pageHeaderTitle", text);
    }
}
</script>

<style scoped>
#InitiateEvaluation {
    padding: 24px;
    background-color: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
}

#InitiateEvaluation .content {
    flex-grow: 1;
    flex-shrink: 2;
    overflow-y: auto;
    margin-top: 30px;
}
</style>